<template>
  <div :class="{'section-loading': isLoading}">
    <h4 class="text-green text-center">保障摘要</h4>
    <section class="row">
      <table class="table datatable">
        <thead>
          <tr>
            <th class="text-center" style="width:10%">保障項目</th>
            <th class="text-center" style="width:10%">承保對象</th>
            <th class="text-center" style="width:10%">年期</th>
            <th class="text-center" style="width:40%">公式內容</th>
            <th class="text-center" style="width:25%">GUID</th>
            <th class="text-center" style="width:5%">順序</th>
          </tr>
        </thead>
        <tbody v-if="formulaData.length">
          <tr v-for="data in formulaData" :key="`formulaData-data-${data.guid}`">
            <td>{{data.item}}</td>
            <td>{{data.target}}</td>
            <td>{{data.year}}</td>
            <td>{{data.content}}</td>
            <td>{{data.guid}}</td>
            <td>{{data.no}}</td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td class="text-center" colspan="6">
              <h3 class="mb-3">查無保障公式</h3>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
  </div>
</template>

<script>
import { getInvestFormulaSummary } from "@/service";
export default {
  name: "InvestFormulaSummary",
  data() {
    return {
      formulaData: [],
      productData: null,
      isLoading: false,
    };
  },
  methods: {
    init() {
      this.isLoading = true;
      getInvestFormulaSummary(
        this.$store.state.userInfo.id,
        this.productData.productId
      ).then((result) => {
        if (result.header && result.header.status == "200") {
          this.formulaData = result.data.map(
            ({
              formulaname,
              underwriting_target_name,
              yearperiod_string,
              formula_detail,
              investtype_formula_id,
              priority,
            }) => {
              return {
                item: formulaname,
                target: underwriting_target_name,
                year: yearperiod_string,
                content: formula_detail,
                guid: investtype_formula_id,
                no: priority,
              };
            }
          );
        }
        this.isLoading = false;
      });
    },
  },
  beforeMount() {
    this.productData = JSON.parse(localStorage.productData);
  },
  mounted() {
    this.init();
  },
};
</script>
